export const AUTH_PREFIX_PATH = "/auth";
export const SIGN_IN_PATH = `${AUTH_PREFIX_PATH}/sign-in`;
export const SIGN_IN_PHONE_PATH = `${AUTH_PREFIX_PATH}/sign-in-phone`;
export const SIGN_UP_PATH = `${AUTH_PREFIX_PATH}/sign-up`;
export const RESET_PASSWORD_PATH = `${AUTH_PREFIX_PATH}/reset-password`;
